import React, { useCallback, useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  changeStudyStatusReducer,
  mapDispatchToProps,
} from "./ChangeStudyStatus.store";
import ChangeStudyStatus from "../../../library/BeyondXLH/ChangeStudyStatus/ChangeStudyStatus";
import { studyStatusesBeyondXLH402 } from "../../../../modules/constants";
import { sendNotification } from "../../../ToastManager/ToastManager";
import { ToastType } from "../../../ToastManager/constants";

export const SmartChangeStudyStatus = (props) => {
  const { studyEnrollmentID, studyStatusID, onUpdate, updateStudyStatus } =
    props;
  const [processing, setIsProcessing] = useState(false);
  const [hasError, setHasError] = useState(false);

  const onSubmit = (data) => {
    if (data?.studyStatus) {
      setIsProcessing(true);
      updateStudyStatus(
        data?.studyStatus.id,
        studyEnrollmentID,
        data?.reason,
        data?.withdrawnDate
      )
        .then((message) => {
          sendNotification(message, ToastType.SUCCESS);
          onUpdate();
          setHasError(false);
        })
        .catch((error) => {
          sendNotification(error, ToastType.ERROR);
          setHasError(true);
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  };

  const getCurrentStudyStatus = useCallback(() => {
    return studyStatusesBeyondXLH402[
      Object.keys(studyStatusesBeyondXLH402).find(
        (statusKey) => studyStatusesBeyondXLH402[statusKey].id === studyStatusID
      )
    ];
  }, [studyStatusID]);

  const getAvailableStudyStatus = useCallback(() => {
    return Object.keys(studyStatusesBeyondXLH402)
      .filter((statusKey) => {
        switch (studyStatusID) {
          case studyStatusesBeyondXLH402.ACTIVE.id:
            return studyStatusesBeyondXLH402[statusKey].id !== studyStatusID;
          case studyStatusesBeyondXLH402.WITHDRAWN.id:
            return [studyStatusesBeyondXLH402.COMPLETED.id].includes(
              studyStatusesBeyondXLH402[statusKey].id
            );
          default:
            return null;
        }
      })
      .map((key) => studyStatusesBeyondXLH402[key]);
  }, [studyStatusID]);

  return (
    <ChangeStudyStatus
      currentStatus={getCurrentStudyStatus()}
      onSubmit={onSubmit}
      onCancel={onUpdate}
      processing={processing}
      values={getAvailableStudyStatus()}
      hasError={hasError}
    />
  );
};

export default dynamic(
  "changeStudyStatusReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(changeStudyStatusReducer)
)(connect(null, mapDispatchToProps)(SmartChangeStudyStatus));
